<script setup lang="ts">
import { computed } from 'vue';
import UiSpinner from '@/modules/ui/components/ui/UiSpinner.vue';

const {
  color = 'gray',
  position = 'absolute',
  size = 'm',
} = defineProps<{
  color?: 'gray' | 'white' | 'transparent';
  position?: 'absolute' | 'static';
  size?: 's' | 'm';
  text?: string;
}>();

const spinnerSize = computed(() => {
  switch (size) {
    case 's':
      return 'm';
    case 'm':
    default:
      return 'l';
  }
});
</script>

<template>
  <div
    class="ui-loader"
    :class="[`_position-${position}`, `_color-${color}`, `_size-${size}`]"
  >
    <UiSpinner :size="spinnerSize" />
    <span
      v-if="text"
      class="text"
    >
      {{ $t(text) }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.ui-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &._position-static {
    height: 100%;
  }

  &._position-absolute {
    position: absolute;
    z-index: var(--z-index-loader);
    inset: 0;
  }

  &._color-gray {
    background-color: var(--color-loader);
    backdrop-filter: blur(4px);
  }

  &._color-white {
    background-color: var(--color-white);
  }

  &._color-transparent {
    background-color: transparent;
  }

  &._size-s {
    .text {
      font-size: var(--font-size-s);
      line-height: var(--line-height-s);
    }
  }
}

.ui-spinner {
  &:not(:last-child) {
    margin-bottom: 12px;
  }
}

.text {
  color: var(--color-gray-600);
  text-align: center;
}
</style>
